import { render } from "./CourseCreditOtherContent.vue?vue&type=template&id=6a37f3a4&scoped=true"
import script from "./CourseCreditOtherContent.vue?vue&type=script&lang=js"
export * from "./CourseCreditOtherContent.vue?vue&type=script&lang=js"

import "./CourseCreditOtherContent.vue?vue&type=style&index=0&id=6a37f3a4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a37f3a4"]])

export default __exports__